"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ASK_CONVERSATION_LIST_PAGE_SIZE () {
        return ASK_CONVERSATION_LIST_PAGE_SIZE;
    },
    get AiQueryRequest () {
        return AiQueryRequest;
    },
    get AiQueryRequestUrlParams () {
        return AiQueryRequestUrlParams;
    },
    get AskAgentType () {
        return AskAgentType;
    },
    get AskMessage () {
        return AskMessage;
    },
    get AskRequest () {
        return AskRequest;
    },
    get DocumentAgentRequest () {
        return DocumentAgentRequest;
    },
    get EngagementAnalysis () {
        return EngagementAnalysis;
    },
    get EngagementCohortAnalysis () {
        return EngagementCohortAnalysis;
    },
    get EngagementCohortFactorsData () {
        return EngagementCohortFactorsData;
    },
    get EngagementCompanyFactorsData () {
        return EngagementCompanyFactorsData;
    },
    get FormAgentRequest () {
        return FormAgentRequest;
    },
    get FormAuthoringCoachAgentRequest () {
        return FormAuthoringCoachAgentRequest;
    },
    get FormBuildingCoachAgentRequest () {
        return FormBuildingCoachAgentRequest;
    },
    get FormQuestionType () {
        return FormQuestionType;
    },
    get GeneralAgentRequest () {
        return GeneralAgentRequest;
    },
    get GetAskConversationParams () {
        return GetAskConversationParams;
    },
    get GetAskConversationsRequest () {
        return GetAskConversationsRequest;
    },
    get GetSavedAIMetaDataResponse () {
        return GetSavedAIMetaDataResponse;
    },
    get GetSavedAIMetaDataUrlParams () {
        return GetSavedAIMetaDataUrlParams;
    },
    get GoalAgentRequest () {
        return GoalAgentRequest;
    },
    get GoalCoachAgentRequest () {
        return GoalCoachAgentRequest;
    },
    get InterviewerAgentRequest () {
        return InterviewerAgentRequest;
    },
    get InterviewerHarnessType () {
        return _harnesstypes.InterviewerHarnessType;
    },
    get MAX_CURRENT_ANSWERS () {
        return MAX_CURRENT_ANSWERS;
    },
    get MAX_CURRENT_ANSWERS_BYTES () {
        return MAX_CURRENT_ANSWERS_BYTES;
    },
    get MAX_CURRENT_ANSWER_LENGTH () {
        return MAX_CURRENT_ANSWER_LENGTH;
    },
    get MAX_CURRENT_FORM_NAME_LENGTH () {
        return MAX_CURRENT_FORM_NAME_LENGTH;
    },
    get MAX_CURRENT_FORM_QUESTIONS () {
        return MAX_CURRENT_FORM_QUESTIONS;
    },
    get MAX_CURRENT_FORM_QUESTION_LENGTH () {
        return MAX_CURRENT_FORM_QUESTION_LENGTH;
    },
    get MAX_CURRENT_FORM_SUBTEXT_LENGTH () {
        return MAX_CURRENT_FORM_SUBTEXT_LENGTH;
    },
    get MeetingWorkspaceInsight () {
        return MeetingWorkspaceInsight;
    },
    get MeetingWorkspaceInsightFilters () {
        return MeetingWorkspaceInsightFilters;
    },
    get PatchCompanyAISettingsRequest () {
        return PatchCompanyAISettingsRequest;
    },
    get PostCompanyAISettingsRequest () {
        return PostCompanyAISettingsRequest;
    },
    get PostEmbeddingsRequest () {
        return PostEmbeddingsRequest;
    },
    get PostMeetingAnalysis () {
        return PostMeetingAnalysis;
    },
    get PreMeetingPrep () {
        return PreMeetingPrep;
    },
    get PriorCompetencySuggestion () {
        return PriorCompetencySuggestion;
    },
    get QueueAIReviewCycleRequest () {
        return QueueAIReviewCycleRequest;
    },
    get REVIEW_REPORT_ID_PATTERN () {
        return REVIEW_REPORT_ID_PATTERN;
    },
    get RephraseFormQuestion () {
        return RephraseFormQuestion;
    },
    get RephraseQuestionType () {
        return RephraseQuestionType;
    },
    get RephraseReviewAnswer () {
        return RephraseReviewAnswer;
    },
    get SummarizeReview () {
        return SummarizeReview;
    },
    get SummarizeReviewCycle () {
        return SummarizeReviewCycle;
    },
    get SurveyAnalysis () {
        return SurveyAnalysis;
    },
    get SurveyInsight () {
        return SurveyInsight;
    },
    get TeamMeetingWorkspaceInsight () {
        return TeamMeetingWorkspaceInsight;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _harnesstypes = require("./harness-types");
const _response = require("./response");
const PostEmbeddingsRequest = _zod.z.object({
    context: _zod.z.string()
});
const PostCompanyAISettingsRequest = _models.AiSettingsSchema;
const PatchCompanyAISettingsRequest = _models.AiSettingsSchema.partial();
const sharedProps = _zod.z.object({
    findAdditionalContext: _zod.z.boolean().optional().default(false),
    context: _zod.z.record(_zod.z.string(), _zod.z.unknown()).optional()
});
const RephraseQuestionType = _zod.z.union([
    _zod.z.literal("text"),
    _zod.z.literal("multiline"),
    _zod.z.literal("goal")
]);
const FormQuestionType = _zod.z.enum([
    "Long answer",
    "Multi-line answer",
    "Numeric",
    "Date",
    "Multiple choice",
    "Instructions",
    "Rating scale",
    "Goal discussion",
    "Goal creation",
    "Numeric calculation"
]);
const RephraseFormQuestion = sharedProps.extend({
    input: _zod.z.string(),
    questionType: FormQuestionType,
    previousResponses: _zod.z.array(_zod.z.string()).optional().default([])
});
const RephraseReviewAnswer = sharedProps.extend({
    answer: _zod.z.array(_zod.z.string()),
    author: _zod.z.string().default(""),
    question: _zod.z.string(),
    subject: _zod.z.string().default(""),
    subText: _zod.z.string().default(""),
    goalName: _zod.z.string().default(""),
    questionType: RephraseQuestionType
});
const SummarizeReview = sharedProps.extend({
    reviewId: _utilsisomorphic.transformObjectId
});
const EngagementAnalysis = sharedProps.extend({
    questionId: _zod.z.string(),
    startDate: _zod.z.string().optional(),
    endDate: _zod.z.string().optional(),
    cohortId: _zod.z.string().nullable().optional()
});
const SummarizeReviewCycle = sharedProps.extend({
    reviewCycleId: _zod.z.string()
});
const MeetingWorkspaceInsightFilters = _zod.z.object({
    status: _zod.z.array(_zod.z.string()).optional(),
    privateNotes: _zod.z.enum([
        "any",
        "has-private-notes",
        "no-private-notes"
    ]).optional(),
    meetingDateStart: _zod.z.string().optional(),
    meetingDateEnd: _zod.z.string().optional()
}).strict();
const workspaceInsightProps = sharedProps.extend({
    workspaceId: _utilsisomorphic.transformObjectId,
    filters: MeetingWorkspaceInsightFilters.optional()
});
const MeetingWorkspaceInsight = workspaceInsightProps;
const TeamMeetingWorkspaceInsight = workspaceInsightProps;
const PreMeetingPrep = sharedProps.extend({
    meetingId: _utilsisomorphic.transformObjectId,
    workspaceId: _utilsisomorphic.transformObjectId
});
const PostMeetingAnalysis = sharedProps.extend({
    meetingId: _utilsisomorphic.transformObjectId,
    workspaceId: _utilsisomorphic.transformObjectId
});
const AskMessage = _zod.z.object({
    role: _zod.z.enum([
        "user",
        "assistant"
    ]),
    content: _zod.z.string()
});
const AskAgentType = _zod.z.enum([
    "document",
    "general",
    "goal",
    "goal-coach",
    "form",
    "form-building-coach",
    "form-authoring-coach",
    "interviewer"
]);
// Base request fields shared by all agents
const AskRequestBase = _zod.z.object({
    query: _zod.z.string().min(1).max(2000),
    messages: _zod.z.array(AskMessage).optional().default([]),
    sessionId: _zod.z.string().optional(),
    /**
	 * The persisted conversation this turn continues (PY-13559). Omitted on the
	 * first turn of a new chat — the server mints one and announces it via the
	 * `conversation` SSE event.
	 *
	 * Distinct from `sessionId`, which stays a per-tab tracing id so Braintrust
	 * spans and llm_log correlation are unaffected by conversation boundaries.
	 */ conversationId: _zod.z.string().optional()
});
// Document agent options - shared between explicit and default requests
const DocumentAgentFilters = _zod.z.object({
    tags: _zod.z.array(_zod.z.string()).optional()
}).optional();
const DocumentAgentOptions = _zod.z.object({
    limit: _zod.z.number().min(1).max(20).optional().default(10),
    minScore: _zod.z.number().min(0).max(1).optional().default(0.5),
    useQueryExpansion: _zod.z.boolean().optional().default(true),
    useReranking: _zod.z.boolean().optional().default(true)
}).optional();
const DocumentAgentRequest = AskRequestBase.extend({
    agent: _zod.z.literal("document"),
    filters: DocumentAgentFilters,
    options: DocumentAgentOptions
});
const GeneralAgentRequest = AskRequestBase.extend({
    agent: _zod.z.literal("general")
});
const GoalAgentRequest = AskRequestBase.extend({
    agent: _zod.z.literal("goal")
});
// Snapshot of the wizard goal sent to the goal-coach agent. Advisory context, mirroring FormAgentCurrentFormContext.
const GoalCoachCurrentGoalContext = _zod.z.object({
    name: _zod.z.string().max(500).default(""),
    description: _zod.z.string().max(12000).default(""),
    target: _zod.z.union([
        _zod.z.string(),
        _zod.z.number()
    ]).optional(),
    units: _zod.z.string().max(100).default(""),
    startDate: _zod.z.string().max(100).default(""),
    endDate: _zod.z.string().max(100).default(""),
    transparency: _zod.z.string().max(100).default(""),
    categories: _zod.z.array(_zod.z.object({
        id: _zod.z.string(),
        name: _zod.z.string()
    })).max(50).default([]),
    checklist: _zod.z.array(_zod.z.object({
        id: _zod.z.string().default(""),
        label: _zod.z.string().max(2000).default("")
    })).max(100).default([])
});
const GoalCoachContext = _zod.z.object({
    currentGoal: GoalCoachCurrentGoalContext.optional()
}).optional();
const GoalCoachAgentRequest = AskRequestBase.extend({
    agent: _zod.z.literal("goal-coach"),
    context: GoalCoachContext
});
const MAX_CURRENT_FORM_QUESTIONS = 150;
const MAX_CURRENT_FORM_NAME_LENGTH = 500;
const MAX_CURRENT_FORM_QUESTION_LENGTH = 3000;
const MAX_CURRENT_FORM_SUBTEXT_LENGTH = 12000;
const FormAgentCurrentFormContext = _zod.z.object({
    // The form builder's route id — stamped onto every formQuestions suggestion so a
    // restored card can tell whether it's being viewed on the form it was suggested for.
    formId: _zod.z.string().optional(),
    name: _zod.z.string().max(MAX_CURRENT_FORM_NAME_LENGTH),
    questions: _zod.z.array(_zod.z.object({
        // The form builder's refId — required by the form-building coach to
        // target improvements; absent on older clients.
        id: _zod.z.string().max(100).optional(),
        // Loose string (not AskSSEFormQuestionType) so legacy types like
        // "stars" / "calculator" pass through — this is advisory context, not a tool input.
        type: _zod.z.string(),
        question: _zod.z.string().max(MAX_CURRENT_FORM_QUESTION_LENGTH).default(""),
        subtext: _zod.z.string().max(MAX_CURRENT_FORM_SUBTEXT_LENGTH).default(""),
        choices: _zod.z.array(_zod.z.string()).optional(),
        rating_scale: _zod.z.array(_response.AskSSEFormRatingScaleOption).max(50).optional(),
        is_required: _zod.z.boolean().optional()
    })).max(MAX_CURRENT_FORM_QUESTIONS)
});
const FormAgentContext = _zod.z.object({
    priorFormSuggestions: _zod.z.array(_response.AskSSEFormSuggestion).optional(),
    currentForm: FormAgentCurrentFormContext.optional()
}).optional();
const FormAgentRequest = AskRequestBase.extend({
    agent: _zod.z.literal("form"),
    context: FormAgentContext
});
const FormBuildingCoachContext = _zod.z.object({
    currentForm: FormAgentCurrentFormContext.optional()
}).optional();
const FormBuildingCoachAgentRequest = AskRequestBase.extend({
    agent: _zod.z.literal("form-building-coach"),
    context: FormBuildingCoachContext
});
const REVIEW_REPORT_ID_PATTERN = /^[0-9a-f]{24}$/i;
const MAX_CURRENT_ANSWERS = 300;
const MAX_CURRENT_ANSWER_LENGTH = 12000;
const MAX_CURRENT_ANSWERS_BYTES = 256 * 1024;
/** One answer as it currently stands in the review page's inputs, addressed by question position.
 *  Values mirror what the page would save: text, a number (rating index / numeric), or a list
 *  (multiline, multi-select). Anything richer (goal discussions) is left to the saved copy. */ const FormAuthoringCoachCurrentAnswer = _zod.z.object({
    index: _zod.z.number().int().min(0).max(MAX_CURRENT_ANSWERS),
    value: _zod.z.union([
        _zod.z.string().max(MAX_CURRENT_ANSWER_LENGTH),
        _zod.z.number(),
        _zod.z.array(_zod.z.string().max(MAX_CURRENT_ANSWER_LENGTH)).max(100)
    ])
});
const FormAuthoringCoachContext = _zod.z.object({
    reviewReportId: _zod.z.string().regex(REVIEW_REPORT_ID_PATTERN).optional(),
    /** Unsaved, on-screen answers. The coach evaluates what the author is looking at, so these
		 *  take precedence over the saved copy for the positions they cover. */ currentAnswers: _zod.z.array(FormAuthoringCoachCurrentAnswer).max(MAX_CURRENT_ANSWERS).optional()
}).optional();
const FormAuthoringCoachAgentRequest = AskRequestBase.extend({
    agent: _zod.z.literal("form-authoring-coach"),
    context: FormAuthoringCoachContext
});
const PriorCompetencySuggestion = _response.AskSSECompetencySuggestion.extend({
    reviewStatus: _zod.z.enum([
        "pending",
        "created",
        "removed"
    ]).default("pending")
});
const InterviewerAgentRequest = AskRequestBase.extend({
    query: _zod.z.string().min(1).max(4000),
    agent: _zod.z.literal("interviewer"),
    harness: _harnesstypes.InterviewerHarnessType,
    interviewNotes: _zod.z.record(_zod.z.string().max(100), _zod.z.unknown()).refine((val)=>Object.keys(val).length <= 50, {
        message: "Too many note keys"
    }).refine((val)=>JSON.stringify(val).length <= 10_000, {
        message: "Notes payload too large"
    }).optional(),
    priorCompetencySuggestions: _zod.z.array(PriorCompetencySuggestion).max(100).refine((val)=>JSON.stringify(val).length <= 50_000, {
        message: "Prior suggestions payload too large"
    }).optional(),
    competencyImportBlocked: _zod.z.boolean().optional()
});
// Default request - when no agent is specified, classification determines routing.
// Carries form + goal-coach context so classified turns from those pages keep working.
const DefaultAgentContext = _zod.z.object({
    priorFormSuggestions: _zod.z.array(_response.AskSSEFormSuggestion).optional(),
    currentForm: FormAgentCurrentFormContext.optional(),
    currentGoal: GoalCoachCurrentGoalContext.optional(),
    reviewReportId: _zod.z.string().regex(REVIEW_REPORT_ID_PATTERN).optional(),
    currentAnswers: _zod.z.array(FormAuthoringCoachCurrentAnswer).max(MAX_CURRENT_ANSWERS).optional(),
    competencyImportBlocked: _zod.z.boolean().optional()
}).optional();
const DefaultAgentRequest = AskRequestBase.extend({
    agent: _zod.z.undefined(),
    filters: DocumentAgentFilters,
    options: DocumentAgentOptions,
    context: DefaultAgentContext
});
const AskRequest = _zod.z.union([
    DocumentAgentRequest,
    GeneralAgentRequest,
    GoalAgentRequest,
    GoalCoachAgentRequest,
    FormAgentRequest,
    FormBuildingCoachAgentRequest,
    FormAuthoringCoachAgentRequest,
    InterviewerAgentRequest,
    DefaultAgentRequest
]);
const EngagementCohortFactorsData = _zod.z.object({
    _id: _zod.z.string().nullable(),
    name: _zod.z.string().nullable(),
    description: _zod.z.string().nullable(),
    satisfaction: _zod.z.number(),
    enps: _zod.z.number(),
    factorsLowestToHighest: _zod.z.array(_zod.z.object({
        factor: _zod.z.string().nullable(),
        average: _zod.z.number().nullable()
    }))
});
const EngagementCompanyFactorsData = _zod.z.object({
    enps: _zod.z.number(),
    satisfaction: _zod.z.number(),
    factors: _zod.z.array(_zod.z.object({
        factor: _zod.z.string(),
        average: _zod.z.number().nullable()
    }))
});
const EngagementCohortAnalysis = sharedProps.extend({
    dateRange: _zod.z.string(),
    companyFactorsData: EngagementCompanyFactorsData,
    cohortFactorsData: EngagementCohortFactorsData
});
const SurveyInsight = sharedProps.extend({
    surveyId: _zod.z.string()
});
const SurveyAnalysis = sharedProps.extend({
    surveyId: _utilsisomorphic.transformObjectId
});
const AiQueryRequest = _zod.z.discriminatedUnion("type", [
    SummarizeReview.extend({
        type: _zod.z.literal("review-insight")
    }),
    SummarizeReview.extend({
        type: _zod.z.literal("review-insight-haiku")
    }),
    RephraseReviewAnswer.extend({
        type: _zod.z.literal("review-authoring-haiku")
    }),
    RephraseReviewAnswer.extend({
        type: _zod.z.literal("review-authoring-sonnet")
    }),
    RephraseFormQuestion.extend({
        type: _zod.z.literal("form-question-rephrase")
    }),
    EngagementAnalysis.extend({
        type: _zod.z.literal("engagement-insight")
    }),
    SummarizeReviewCycle.extend({
        type: _zod.z.literal("review-cycle-insight")
    }),
    SummarizeReviewCycle.extend({
        type: _zod.z.literal("review-cycle-insight-haiku")
    }),
    EngagementCohortAnalysis.extend({
        type: _zod.z.literal("engagement-cohort-insights")
    }),
    SurveyInsight.extend({
        type: _zod.z.literal("survey-insight")
    }),
    MeetingWorkspaceInsight.extend({
        type: _zod.z.literal("meeting-workspace-insight")
    }),
    TeamMeetingWorkspaceInsight.extend({
        type: _zod.z.literal("team-meeting-workspace-insight")
    }),
    PreMeetingPrep.extend({
        type: _zod.z.literal("pre-meeting-prep")
    }),
    PostMeetingAnalysis.extend({
        type: _zod.z.literal("post-meeting-analysis")
    })
]);
const AiQueryRequestUrlParams = _zod.z.object({
    retry: _zod.z.string().default("false"),
    responseStyle: _models.LlmResponseStyle
});
const GetSavedAIMetaDataUrlParams = _zod.z.object({
    promptKey: _zod.z.string(),
    promptValue: _zod.z.string(),
    recreate: _zod.z.string().default("false")
});
const GetSavedAIMetaDataResponse = _zod.z.object({
    userId: _zod.z.instanceof(_bson.ObjectId).or(_zod.z.undefined()),
    createdAt: _zod.z.date().or(_zod.z.undefined()),
    completed: _zod.z.boolean().default(false)
});
/**
 * One input to a review cycle insight merge: either an individual review summary
 * (`review-insight-haiku` output, keyed on strengths/opportunities/actionItems) or an
 * already-merged aggregate (`review-cycle-insight-haiku` output, keyed on
 * strengthsAnalysis/highlightedReviews/...).
 *
 * This replaced a union of the two response schemas. Zod strips unrecognized keys, so the
 * union kept only the fields of whichever member matched first: every individual summary
 * also satisfied the aggregate shape and was reduced to `insight.summary` alone, losing its
 * strengths, opportunities, action items, disconnects, quotes, tone and subject before the
 * merge prompt ever saw them (PY-14383).
 *
 * Loose rather than strict for the same reason. The merge prompt renders the whole object,
 * so a field this schema does not name is a field the model never sees — and the producers
 * change independently of it (`buildReviewCycleInsightSchema` is built at runtime from
 * company settings). Enumerating the known fields documents both shapes and types the
 * consumers; staying loose keeps a newly added section from silently going missing.
 *
 * Item caps and defaults belong on the response schemas, not here. A cap on an input
 * rejects a legitimately longer summary instead of accepting it, and a default on an input
 * invents a value the model cannot tell apart from one a producer actually emitted.
 * Nested objects stay loose for the same reason the outer one does — a strict `z.object`
 * inside a `looseObject` still strips the keys it does not name.
 */ const ReviewCycleInsightMergeInput = _zod.z.looseObject({
    createdAt: _zod.z.string().optional(),
    completed: _zod.z.boolean().optional(),
    createdBy: _zod.z.string().optional(),
    subject: _zod.z.looseObject({
        _id: _zod.z.string(),
        name: _zod.z.string()
    }).optional(),
    title: _zod.z.string(),
    startDate: _zod.z.string().optional(),
    completedDate: _zod.z.string().optional(),
    insight: _zod.z.looseObject({
        summary: _zod.z.string(),
        // Individual review summary
        strengths: _zod.z.array(_zod.z.string()).optional(),
        opportunities: _zod.z.array(_zod.z.string()).optional(),
        actionItems: _zod.z.array(_zod.z.string()).optional(),
        disconnects: _zod.z.array(_zod.z.string()).optional(),
        generalAssessment: _zod.z.string().optional(),
        quotes: _zod.z.array(_zod.z.string()).optional(),
        tone: _zod.z.string().optional(),
        // Aggregated summary
        reviewToneDistribution: _zod.z.array(_zod.z.string()).or(_zod.z.string()).optional(),
        highlightedReviews: _zod.z.looseObject({
            topPerformers: _zod.z.array(_zod.z.string()).optional(),
            attentionRequired: _zod.z.array(_zod.z.string()).optional(),
            growthOpportunities: _zod.z.array(_zod.z.string()).optional()
        }).optional(),
        strengthsAnalysis: _zod.z.array(_zod.z.string()).optional(),
        opportunitiesAnalysis: _zod.z.array(_zod.z.string()).optional(),
        commonThemesForPositiveReviews: _zod.z.array(_zod.z.string()).optional(),
        commonThemesForNegativeReviews: _zod.z.array(_zod.z.string()).optional(),
        recurringActionItems: _zod.z.array(_zod.z.string()).optional(),
        disconnectsAnalysis: _zod.z.array(_zod.z.string()).optional()
    }).or(_zod.z.string())
});
const QueueAIReviewCycleRequest = _zod.z.object({
    createdBy: _zod.z.string(),
    summary_one: ReviewCycleInsightMergeInput,
    summary_two: ReviewCycleInsightMergeInput,
    reviewCycleId: _zod.z.string(),
    reviewCycleName: _zod.z.string(),
    reviewCycleStartDate: _zod.z.string().or(_zod.z.date()),
    reviewCycleTemplate: _zod.z.string(),
    reviewCycleGroupName: _zod.z.string().nullish(),
    reviewCycleTotal: _zod.z.number()
});
const ASK_CONVERSATION_LIST_PAGE_SIZE = 5;
const GetAskConversationsRequest = _zod.z.object({
    limit: _zod.z.coerce.number().int().min(1).max(50).optional().default(ASK_CONVERSATION_LIST_PAGE_SIZE),
    /** Opaque `nextCursor` from the previous page. */ cursor: _zod.z.string().optional(),
    /** Matches conversation titles only — not the stored preview, not transcript bodies. */ search: _zod.z.string().max(200).optional()
});
const GetAskConversationParams = _zod.z.object({
    conversationId: _zod.z.string()
});
